import { render } from "./HomeCliente.vue?vue&type=template&id=c929da9c"
import script from "./HomeCliente.vue?vue&type=script&lang=js"
export * from "./HomeCliente.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__